import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { isUserHasAccess } from "../utils/utils";
const feature_Path_map = {
  "/home": "Home",
  "/admin/approvals": "Approvals",
  "/admin/brandmaintenance": "Brand Maintenance",
  "/admin/kpidashboard": "KPI Dashboard",
  "/admin/dataGovernance": "Data Governance",
  "/admin/approvals/details": "Approvals",
  "/discover": "Discover",
  "/assist": "Assist",
  "/myapps": "My Apps",
  "/saved": "Saved",
  "/admin": "Admin",
  "/resources": "Docs",
  "/faq": "FAQs",
  "/help": "Help",
  "/rapid": "Rapid",
  "/myapps/register-report": "Report",
  "/myapps/register-data_asset": "Data Asset",
  "/myapps/register-application": "Application",
  "/dataCoverage": "Data Coverage",
};
const ProtectedRoute = ({ page, optional_endpoint = "", children }) => {
  const pathName = useLocation()?.pathname;

  const final_endpoint = optional_endpoint || pathName;

  const accessList = useSelector(
    (state) => state.auth.metadata?.accessList || []
  );

  if (!feature_Path_map.hasOwnProperty(final_endpoint)) {
    return children;
  }

  const feature_name = feature_Path_map[final_endpoint];

  const flag = isUserHasAccess(accessList, page, feature_name);
  if (!flag) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
